const GOOGLE_PREFIX = 'gsc';

const HASH_PARAMS_TEMPLATE = {
  q: '',
  sort: '',
  page: '',
};

const getGoogleParams = () => {
  const { hash } = window.location;
  const params = { ...HASH_PARAMS_TEMPLATE };

  // Google prefixes each param in the hash with "gsc.<KEY>=<VALUE>"
  if (!hash.includes('gsc')) {
    return params;
  }

  const queryString = hash.replace('#', '');
  const splitQueryString = queryString.split('&');

  splitQueryString.forEach((param) => {
    const paramWithoutPrefix = param.replace('gsc.', '');
    const [paramKey, paramValue] = paramWithoutPrefix.split('=');

    params[paramKey] = paramValue || '';
  });

  return params;
};

const buildGoogleParamsHash = (updatedParams = {}) => {
  const params = {
    ...getGoogleParams(),
    ...updatedParams,
  };

  const formattedParams = Object.entries(params).map((entry) => {
    const [paramKey, paramValue] = entry;
    const googleKey = [GOOGLE_PREFIX, paramKey].join('.');

    return `${googleKey}=${paramValue}`;
  });

  const queryString = formattedParams.join('&');

  return `#${queryString}`;
};

const getCurrentPageFromUrl = () => {
  const { page } = getGoogleParams();

  if (!page) {
    return 1;
  }

  return parseInt(page);
};

export { buildGoogleParamsHash, getCurrentPageFromUrl, getGoogleParams };
